import React, { useEffect, useState } from "react";
import { Button, Dropdown, Flex, Menu, Select, Tooltip } from "antd";
import { SvgIcons } from "Icon/SvgIcons";
import CandidateModal from "components/Common/Candidate Actions/AddToTalentPool";
import DislikeButton from "components/Common/Candidate Actions/DislikeButton";
import SendEmail from "components/CandidateProfile/SendEmail";
import { useAppSelector } from "hooks/reduxHooks";
import { useFeatureAllowedFromState } from "services/CustomeHooks";
import { FEATURE_CONSTANTS } from "components/constants/AppConstants";
import SendBulkEmail from "components/CandidateProfile/SendBulkEmail";
import verifiedtick from "../../images/verifiedtick.svg";
import EditIcon from "../../images/editIcon.svg";
import { getCandidate } from "api/candidate.api";
import { creditsRefreshChanger } from "store/slices/refresh.slice";
import { useDispatch } from "react-redux";
import { setBulkMailTalentPool } from "store/slices/candidateBulkMail.slice";
import { CheckOutlined, DownOutlined, EditFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { readUser } from "services/localStorage.service";

interface DrawerHeaderProps {
  candidateDetails?: any;
  candidateId?: number;
  selectedPool?: any;
  isHideEditProjectButton?: boolean;
  isUserProject?: boolean;
  configs?: any;
}

const DrawerHeader: React.FC<DrawerHeaderProps> = ({ candidateDetails, candidateId, selectedPool, isHideEditProjectButton, isUserProject, configs }: any) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const userData = useAppSelector((state) => state.user);
  const [open, setOpen] = useState(true);
  const getUserInfo = readUser();
  const isFeatureAllowed = useFeatureAllowedFromState(FEATURE_CONSTANTS.FCEI);
  const selectedCandidates = useAppSelector((state) => state.candidateBulkMail.candidates) || [];
  const isEmailDisabled = () => {
    return !userData.user?.email_enabled || !isFeatureAllowed;
  };
  const showModal = () => {
    setIsModalVisible(true);
  };

  const handleCancel = () => {
    setIsModalVisible(false);
  };
  const TooltipTitle = (() => {
    if (!userData.user?.email_enabled) {
      return "Please enable the email configuration from settings!";
    } else {
      return null;
    }
  })();

  const [candidateData, setCandidateData] = useState<any>(null);
  const [isMail, setIsMail] = useState<any>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);
  const [candidateNotes, setCandidateNotes] = useState<any>(null);
  const [selectedKey, setSelectedKey] = useState('1');
  const [visible, setVisible] = useState(false);
  const dispatch = useDispatch();
  const [orderedEmails, setOrderedEmails] = useState<any>([]);

  const getEditedField = (key: string, fallbackKey: string) => {
    // const values = candidateNotes?.map((note: any) => note.custom_fields?.[key]).filter(Boolean) || [];
    const values = candidateNotes?.map((note: any) => note.custom_fields?.[key])
      .filter((val: any) => (key === "document" && val !== undefined) || Boolean(val)) || [];
    // .filter((val: any) => key === "document" || Boolean(val)) || [];
    return values.length > 0 ? values[0] : candidateData?.[fallbackKey] || (key === "work_experience" ? [] : "") || (key === "education_experience" ? [] : "") || (key === "emails" ? [] : "") || (key === "phone_numbers" ? [] : "") || (key === "other_profiles_urls" ? [] : "");
  };

  const editedEmails = getEditedField("emails", "emails");

  const emailOptions =
    editedEmails
      ?.slice() // copy to avoid mutating original
      .reverse() // latest added at top
      .map((email: string) => {
        const isOriginal = candidateData?.emails?.includes(email);
        const isEdited = candidateNotes?.some(
          (note: any) => note?.custom_fields?.emails?.includes(email)
        );

        return {
          value: email,
          label: isOriginal ? email : isEdited ? `${email} *` : email,
        };
      }) || [];

  const getCandidateById = async () => {
    if (typeof candidateId === "number") {
      setLoading(true);
      setError(null);
      let data;
      try {
        data = await getCandidate(candidateId);
        setCandidateData(data?.full_profile);
        setCandidateNotes(data?.notes);
      } catch (err) {
        setError("Failed to load candidate data");
      } finally {
        setLoading(false);
        if (candidateData) {
          if (candidateData?.graph_profile_id !== data?.full_profile?.graph_profile_id) {
            dispatch(creditsRefreshChanger());
          }
        } else {
          dispatch(creditsRefreshChanger());
        }
      }
    }
  };

  useEffect(() => {
    if (candidateId) {
      getCandidateById();
    }
  }, [candidateId]);

  useEffect(() => {
    if (emailOptions) {
      setOrderedEmails(emailOptions);
    }
  }, [candidateNotes]);

  const setBulkMailCandidate = () => {
    if (selectedPool) {
      dispatch(setBulkMailTalentPool(selectedPool));
    }
  };

  useEffect(() => {
    if (candidateData) {
      setBulkMailCandidate();
    }
  }, [candidateData]);

  useEffect(() => {
    setIsMail(selectedCandidates[0]?.email?.length > 0);
  }, [isFeatureAllowed, selectedCandidates]);

  // useEffect(() => {
  //   if (candidateId && isFeatureAllowed && open) {
  //     getCandidateById();
  //   }
  // }, [candidateId, isFeatureAllowed, open]);

  useEffect(() => {
    if (candidateId && isFeatureAllowed && open) {
      setCandidateData(candidateDetails);
    }
  }, [candidateDetails]);

  const items = [
    { key: '1', label: 'Add Document' },
    { key: '2', label: 'Add Notes' },
    { key: '3', label: 'Edit Description' },
    { key: '4', label: 'Edit Contact' },
    { key: '5', label: 'Edit Name' },
  ];

  const navigate = useNavigate();

  const handleItemClick = (key: any) => {
    setSelectedKey(key);
    navigate(`/edit/candidate/${candidateId}`, {
      state: {
        candidateDetails: candidateDetails,
        candidateId: candidateId,
        selectedPool: selectedPool,
        editType: items.find(item => item.key === key)?.label
      },
    });
  };

  const menuContent = (
    <div className="border border-[#D0D5DD] rounded-lg" style={{ backgroundColor: "#FFF", padding: "6px", width: '200px' }}>
      {items.map((item) => (
        <div
          key={item.key}
          onClick={() => handleItemClick(item.key)}
          className="flex justify-between items-center"
          style={{ cursor: "pointer", backgroundColor: `${selectedKey === item.key ? '#F0F9FF' : '#FFF'}` }}
        >
          <span className={`edit-dropdown-tab ${selectedKey === item.key && 'selected'}`} style={{ padding: "10px" }}>{item.label}</span>
          {selectedKey === item.key && <CheckOutlined className="text-violet-600" />}
        </div>
      ))}
    </div>
  );

  const handleEditCandidateProfile = () => {
    console.log("Edit candidate profile clicked");
    navigate(`/edit/candidate/${candidateId}`, {
      state: {
        candidateDetails: candidateDetails,
        candidateId: candidateId,
        selectedPool: selectedPool,
        // editType: items.find(item => item.key === key)?.label
      },
    });
  };
  const isEmailNotAllowed = isUserProject && !configs.email;

  return (
    <>
      <Flex gap={8} justify="space-between" align="center" className="flex-grow">
        <Flex gap={12}>
          {isHideEditProjectButton && (
            <Button
              className="relative font-normal text-sm py-2 px-3 bg-transparent border-none flex gap-1 rounded-lg group text-text-tertiary shadow-none"
              onClick={() => navigate(-1)}
              icon={
                <svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M16.6663 10H3.33301M3.33301 10L8.33301 15M3.33301 10L8.33301 5"
                    stroke="#667085"
                    strokeWidth="1.5"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              }
            />
          )}

          {/* <Button className="relative overflow-hidden font-semibold  text-sm text-white rounded-lg py-2 px-3 shadow-md bg-[#845dda] border border-[#7F56D9] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-lg after:border after:border-[#8e69dd] flex gap-1">
            {SvgIcons.whiteMailSvg} Send Message
          </Button> */}
          {!isEmailNotAllowed && isMail ? (
            // <SendEmail
            //   customButton={
            //     TooltipTitle ? <Tooltip title={TooltipTitle}>
            //       <Button disabled={isEmailDisabled()} className="relative overflow-hidden font-semibold  text-sm text-text-tertiary rounded-lg py-[10px] px-[14px] shadow-md bg-[#FFF] border border-[#D0D5DD] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-lg after:border after:border-[#8e69dd] flex gap-1">
            //         {SvgIcons.blackStarSvg} Send Message
            //       </Button>
            //     </Tooltip> :
            //       <>
            //         <SendBulkEmail
            //           customButton={
            //           <Tooltip
            //             title={<span className="flex">
            //               {SvgIcons.blackStarSvg} Send Message
            //             </span>}
            //             placement="top"
            //             overlayClassName="custom-tooltip"
            //           >
            //           <a
            //             className="relative"
            //             href={undefined}
            //             target="_blank"
            //             rel="noreferrer"
            //             onClick={(e) => {
            //               e.preventDefault(); // Prevents the default navigation
            //             }}
            //           >
            //             {SvgIcons.mailBigSvg}
            //             <img src={verifiedtick} className="absolute w-2.5 h-2.5 top-0 right-[-4px]" />
            //           </a>
            //           </Tooltip>
            //         }
            //         profileData={candidateData}
            //         autoGenerate={true}
            //         emails={candidateData && candidateData.emails ? candidateData.emails : []}
            //         profileId={candidateData?.graph_profile_id}
            //         candidateId={candidateData}
            //       ></SendBulkEmail>
            //       <Button disabled={isEmailDisabled()} className="relative overflow-hidden font-semibold  text-sm text-text-tertiary rounded-lg py-[10px] px-[14px] shadow-md bg-[#FFF] border border-[#D0D5DD] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-lg after:border after:border-[#8e69dd] flex gap-1">
            //         {SvgIcons.blackStarSvg} Send Message
            //       </Button>
            //     </>

            //   }
            //   profileData={candidateDetails}
            //   autoGenerate={true}
            //   emails={candidateDetails && candidateDetails.emails ? candidateDetails.emails : []}
            //   profileId={candidateDetails?.graph_profile_id}
            //   candidateId={candidateId}
            // ></SendEmail>
            <SendBulkEmail
              customButton={
                <Button 
                className="text-white py-2 px-3 bg-[#845dda] border border-[#7F56D9] flex gap-1 rounded-lg group"
                // type="primary" 
                disabled={isEmailDisabled()} 
                // className="relative overflow-hidden font-semibold  text-sm text-text-tertiary rounded-lg py-[10px] px-[14px] shadow-md bg-[#FFF] border border-[#D0D5DD] after:content-[''] after:absolute after:top-0 after:left-0 after:w-full after:h-full after:rounded-lg after:border after:border-[#8e69dd] flex gap-1"
                icon={<svg
                  width="20"
                  height="20"
                  viewBox="0 0 20 20"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M8.74928 11.2501L17.4993 2.50014M8.85559 11.5235L11.0457 17.1552C11.2386 17.6513 11.3351 17.8994 11.4741 17.9718C11.5946 18.0346 11.7381 18.0347 11.8587 17.972C11.9978 17.8998 12.0946 17.6518 12.2881 17.1559L17.78 3.08281C17.9547 2.63516 18.0421 2.41133 17.9943 2.26831C17.9528 2.1441 17.8553 2.04663 17.7311 2.00514C17.5881 1.95736 17.3643 2.0447 16.9166 2.21939L2.84349 7.71134C2.34759 7.90486 2.09965 8.00163 2.02739 8.14071C1.96475 8.26129 1.96483 8.40483 2.02761 8.52533C2.10004 8.66433 2.3481 8.7608 2.84422 8.95373L8.47589 11.1438C8.5766 11.183 8.62695 11.2026 8.66935 11.2328C8.70693 11.2596 8.7398 11.2925 8.7666 11.3301C8.79685 11.3725 8.81643 11.4228 8.85559 11.5235Z"
                    stroke="currentColor"
                    strokeWidth="1.66667"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>}>
                  Send Email
                </Button>
              }
              profileData={candidateData}
              autoGenerate={true}
              // emails={candidateData && candidateData.emails ? candidateData.emails : []}
              emails={candidateData && orderedEmails ? orderedEmails : []}
              profileId={candidateData?.graph_profile_id}
              candidateId={candidateData}
            ></SendBulkEmail>
          ) : (
            ""
          )}
          {/* <Select
            prefix={<img src={EditIcon} alt="" />}
            suffixIcon={<CheckOutlined />} 
            defaultValue="Edit profile"
            // onChange={handleChange}
            style={{ fontSize: "12px", fontWeight: 500, color: "#6941C6" }}
            options={[
              { value: 'add-document', label: 'Add Document' },
              { value: 'add-note', label: 'Add Notes' },
              { value: 'edit-description', label: 'Edit Description' },
              { value: 'edit-contact', label: 'Edit Contact' },
              { value: 'edit-name', label: 'Edit Name' }
            ]}
          /> */}
          {/* <Dropdown
            open={visible}
            onOpenChange={setVisible}
            dropdownRender={() => menuContent}
            trigger={['click']}
            placement="bottomLeft"
          >
            <Button onClick={() => setVisible(!visible)} style={{ fontSize: 14, fontFamily: 'Inter', fontWeight: '600', color: "#475467", backgroundColor: "#FFFFFF" }} className="relative overflow-hidden rounded-lg py-[10px] px-[14px] border border-[#D0D5DD] flex gap-1">
              {SvgIcons.pencil2} <span>Edit</span> Profiles {SvgIcons.chevronDown}
            </Button>
          </Dropdown> */}
          {!isHideEditProjectButton && getUserInfo.role !== "EXTERNAL_CONTRIBUTOR" && (
            <Button onClick={handleEditCandidateProfile} style={{ fontSize: 14, fontFamily: 'Inter', fontWeight: '600', color: "#475467", backgroundColor: "#FFFFFF" }} className="relative overflow-hidden rounded-lg py-[10px] px-[14px] border border-[#D0D5DD] flex gap-1">
              {SvgIcons.pencil2} <span>Edit</span> Profile
            </Button>
          )}

        </Flex>
        {getUserInfo.role !== "EXTERNAL_CONTRIBUTOR" && <div className="flex justify-center gap-2.5">
          <button
            onClick={showModal}
            className="text-text-quaternary w-8 h-8 flex items-center justify-center hover:bg-[#F9F5FF] hover:text-[#6941C6] rounded-full"
          >
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M16.7246 5.48419C16.489 4.93863 16.1493 4.44425 15.7244 4.02872C15.2993 3.61196 14.798 3.28076 14.2479 3.05314C13.6774 2.81617 13.0656 2.69488 12.4479 2.6963C11.5813 2.6963 10.7357 2.93361 10.001 3.38185C9.8252 3.48907 9.6582 3.60685 9.5 3.73517C9.3418 3.60685 9.1748 3.48907 8.99902 3.38185C8.26426 2.93361 7.41875 2.6963 6.55215 2.6963C5.92812 2.6963 5.32344 2.81583 4.75215 3.05314C4.2002 3.28165 3.70273 3.61036 3.27559 4.02872C2.85019 4.44378 2.51037 4.93828 2.27539 5.48419C2.03105 6.05197 1.90625 6.65489 1.90625 7.2754C1.90625 7.86075 2.02578 8.47071 2.26309 9.09122C2.46172 9.60978 2.74648 10.1477 3.11035 10.6908C3.68691 11.5504 4.47969 12.4469 5.46406 13.3557C7.09531 14.8621 8.71074 15.9027 8.7793 15.9449L9.1959 16.2121C9.38047 16.3299 9.61777 16.3299 9.80234 16.2121L10.2189 15.9449C10.2875 15.901 11.9012 14.8621 13.5342 13.3557C14.5186 12.4469 15.3113 11.5504 15.8879 10.6908C16.2518 10.1477 16.5383 9.60978 16.7352 9.09122C16.9725 8.47071 17.092 7.86075 17.092 7.2754C17.0938 6.65489 16.9689 6.05197 16.7246 5.48419ZM9.5 14.8217C9.5 14.8217 3.24219 10.8121 3.24219 7.2754C3.24219 5.48419 4.72402 4.03224 6.55215 4.03224C7.83711 4.03224 8.95156 4.74943 9.5 5.79708C10.0484 4.74943 11.1629 4.03224 12.4479 4.03224C14.276 4.03224 15.7578 5.48419 15.7578 7.2754C15.7578 10.8121 9.5 14.8217 9.5 14.8217Z"
                fill="currentColor"
              />
            </svg>
          </button>

          {selectedPool && (
            <Tooltip title="Reject Candidate">
              <DislikeButton selectedPool={selectedPool} selectedCandidates={[candidateId!]} />
            </Tooltip>
          )}

          {/* <button className="text-text-quaternary w-8 h-8 flex items-center justify-center hover:bg-[#F9F5FF] hover:text-[#6941C6] rounded-full">
            <svg
              width="19"
              height="19"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M6.9425 10.6325L12.065 13.6175M12.0575 5.3825L6.9425 8.3675M16.25 4.25C16.25 5.49264 15.2426 6.5 14 6.5C12.7574 6.5 11.75 5.49264 11.75 4.25C11.75 3.00736 12.7574 2 14 2C15.2426 2 16.25 3.00736 16.25 4.25ZM7.25 9.5C7.25 10.7426 6.24264 11.75 5 11.75C3.75736 11.75 2.75 10.7426 2.75 9.5C2.75 8.25736 3.75736 7.25 5 7.25C6.24264 7.25 7.25 8.25736 7.25 9.5ZM16.25 14.75C16.25 15.9926 15.2426 17 14 17C12.7574 17 11.75 15.9926 11.75 14.75C11.75 13.5074 12.7574 12.5 14 12.5C15.2426 12.5 16.25 13.5074 16.25 14.75Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button> */}

          {/* <button className="text-text-quaternary w-8 h-8 flex items-center justify-center hover:bg-[#F9F5FF] hover:text-[#6941C6] rounded-full">
            <svg
              width="22"
              height="22"
              viewBox="0 0 19 19"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.5 10.25C9.91421 10.25 10.25 9.91421 10.25 9.5C10.25 9.08579 9.91421 8.75 9.5 8.75C9.08579 8.75 8.75 9.08579 8.75 9.5C8.75 9.91421 9.08579 10.25 9.5 10.25Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 5C9.91421 5 10.25 4.66421 10.25 4.25C10.25 3.83579 9.91421 3.5 9.5 3.5C9.08579 3.5 8.75 3.83579 8.75 4.25C8.75 4.66421 9.08579 5 9.5 5Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path
                d="M9.5 15.5C9.91421 15.5 10.25 15.1642 10.25 14.75C10.25 14.3358 9.91421 14 9.5 14C9.08579 14 8.75 14.3358 8.75 14.75C8.75 15.1642 9.08579 15.5 9.5 15.5Z"
                stroke="currentColor"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button> */}
        </div>
        }
        {/* <div>{SvgIcons.upRightArrowSvg}</div> */}
      </Flex>
      <CandidateModal
        isVisible={isModalVisible}
        onClose={handleCancel}
        selectedCandidates={[candidateId!]}
        isAddToProject={true}
      />
    </>
  );
};

export default DrawerHeader;
